export enum DiscountType {
  COMPLIMENTARY = 'complimentary',
  PERCENT = 'percentageoffretail',
  FIXED_AMOUNT = 'fixedamountoffretail',
  COST_PLUS_PERCENT = 'costpluspercentage',
  COST_PLUS_AVERAGE = 'costplusaverage',
}
